import { Injectable }     from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { Observable }     from '../../../node_modules/rxjs/Observable';

import { Vehicle } from '../entities/vehicle';
import { Tracker } from '../entities/tracker';
import { Customer } from '../entities/customer';

import { SERVER_URL } from './server-url';

@Injectable()   
export class VehicleService {
    private vehicleUrl = SERVER_URL + '/api/vehicles';  // URL to web API
    //private trackerUrl = 'http://104.198.40.29:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://localhost:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://192.168.15.8:3005/api/delivery';  // URL to web API
    
    public vehicles:Array<Vehicle>;

    constructor (private http: Http) {}

    getVehicles(tokenLogged:string): Observable<Vehicle[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.get(this.vehicleUrl, {headers: headers})
                    .map(this.extractVehiclesFromJSON)
                    .catch(this.handleError);
    }
    
    private extractVehiclesFromJSON(res: Response | any) {
        let body = res.json();
        var vehicleList:Vehicle[] = []; 

        for (let entry of body) {
            if (!entry.id) { return; }
            var vehicle:Vehicle = new Vehicle(
                entry.id, 
                entry.name, 
                entry.plate, 
                entry.brand, 
                entry.model, 
                entry.color, 
                entry.cc, 
                entry.type, 
                entry.species, 
                entry.fuel, 
                entry.y_mod, 
                entry.y_fab, 
                entry.renavam, 
                entry.seal, 
                entry.chassi, 
                entry.odometer, 
                new Tracker(entry.tracker_id, null, null, null, null, null, null), 
                new Customer(entry.customer_id, null, null, null, null), 
                entry.photo,
                entry.min_weight,
                entry.max_weight,
                entry.max_velocity
            );
            vehicle.logisticCost = entry.logistic_cost;
                
            vehicleList.push(vehicle);
        }
        
        return vehicleList;
    }

    insertVehicle(tokenLogged:string, vehicle:Vehicle): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.post(this.vehicleUrl + '/insert', vehicle, {headers: headers})
                    .map(this.resultInsert)
                    .catch(this.handleError);
    }

    updateVehicle(tokenLogged:string, vehicle:Vehicle): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.post(this.vehicleUrl + '/update', vehicle, {headers: headers})
                    .map(this.resultInsert)
                    .catch(this.handleError);
    }

    private resultInsert(res: Response | any) {
        let body = res.json();
        //console.log("retorno insert => " + body);
    }

    getVehicleById(tokenLogged:string, id:number): Observable<Vehicle> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.get(this.vehicleUrl + '/' + id, {headers: headers})
                    .map(this.extractVehicleFromJSON)
                    .catch(this.handleError);
    }

    private extractVehicleFromJSON(res: Response | any) {
        let body = res.json();
        let entry = body[0];
        //console.log('Tracker ID recebido -> ' + entry.tracker_id);

        if (!entry.id) { return; }

        var vehicle:Vehicle = new Vehicle(
            entry.id, 
            entry.name, 
            entry.plate, 
            entry.brand, 
            entry.model, 
            entry.color, 
            entry.cc, 
            entry.type, 
            entry.species, 
            entry.fuel, 
            entry.y_mod, 
            entry.y_fab, 
            entry.renavam, 
            entry.seal, 
            entry.chassi, 
            entry.odometer,
            new Tracker(entry.tracker_id, null, null, null, null, null, null), 
            new Customer(entry.customer_id, null, null, null, null), 
            entry.photo,
            entry.min_weight,
            entry.max_weight,
            entry.max_velocity
        );
        vehicle.logisticCost = entry.logistic_cost;

        //console.log('tracker id setado no obj ' + vehicle.tracker.id);
        return vehicle;
    }

    deleteVehicle(tokenLogged:string, vehicle:Vehicle) {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.post(this.vehicleUrl + '/deactivate', vehicle, {headers: headers})
                    .map(this.deleteCompanyExtractFromJSON)
                    .catch(this.handleError);
        
        
    }

    private deleteCompanyExtractFromJSON(res: Response | any) {
        //console.log('Excluído');
        let body = res.json();
        let entry = body[0];
        //console.log('res -> ' + entry);

    }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            
            //errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
            errMsg = body.detail || 'Ocorreu um erro no servidor.';
        } 
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }
    
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/services/vehicle.service.ts